import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';
import Home from './screens/Home';
import Layout from './screens/Layout';
import './styles/styles.scss';
import NotFound from './screens/NotFound';

const App = () => (
  <Router>
    <Layout>
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Layout>
  </Router>
);

export default App;
